module.exports = __webpack_public_path__ + "img/gambling-therapy.7c6a2f95.svg";